import { getRoot } from 'mobx-state-tree';

export const getOrgFprintFromStoreNode = (node) =>
  getRoot(node).user.getCurrentOrgFprint();

export const isUnifiedPlatform = (node) =>
  getRoot(node).user.flags.isUnifiedPlatform();
